import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { AppBar, Toolbar } from '@mui/material';
import { Link } from 'react-router-dom';
//import NotificationsIcon from '@mui/icons-material/Notifications';

import Image from '../Image';
import SeparatorVertical from '../SeparatorVertical';
import AccountBadge from './components/AccountBadge';
import NotificationsBadge from './components/NotificationsBadge';
import { ReactComponent as SplitLogo } from '../../assetsNew/logo.svg';
import shopifyAvailableIcon from '../../assetsNew/shopify_available.png';
import shopifyUnavailableIcon from '../../assetsNew/shopify_unavailable.png';
import { routes } from '../../pages';
import { localeFormatCurrency, isEmptyValue } from '../../utils/custom';

import './_navbar.scss';

const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState({ account: null, notifications: null });
  //const { data } = useSelector(s => s.notifications);
  const { data: accountData = {} } = useSelector(s => s.account);
  const { first_name = '', avatar_url } = accountData;
  const { data: creditsData = {} } = useSelector(s => s.getBillingCreditsBalance);
  const { data: shopifyStatusData = {}, loading: shopifyStatusLoading } = useSelector(s => s.getShopifyStatus);
  const { available_cents } = creditsData;

  const isShopifyConnected = shopifyStatusData?.connected === true;
  const shopifyStatusLabel = shopifyStatusLoading ? '...' : (isShopifyConnected ? 'Connected' : 'Not Connected');
  const shopifyStatusClassName = shopifyStatusLoading
    ? 'unknown'
    : (isShopifyConnected ? 'connected' : 'not-connected');
  const shopifyStatusIcon = isShopifyConnected ? shopifyAvailableIcon : shopifyUnavailableIcon;

  const handleMenuOpen = (key, event) => setAnchorEl({ ...anchorEl, [key]: event.currentTarget });
  const handleMenuClose = key => setAnchorEl({ ...anchorEl, [key]: null });

  const renderAccountBadge = () => <AccountBadge closeMenu={() => handleMenuClose('account')} anchorEl={anchorEl.account} />;
  const renderNotificationsBadge = () => <NotificationsBadge closeMenu={() => handleMenuClose('notifications')} anchorEl={anchorEl.notifications} />;

  return (
    <div className="navbar">
      <AppBar position="static">
        <Toolbar classes={{ regular: 'regular-toolbar' }}>
          <Link className="left" to={routes.root.path}>
            <SplitLogo className="logo-image" />
            <SeparatorVertical />
            <p className="app-title">Business</p>
          </Link>
          <div className="right">
            {/*<IconButton color="inherit" onClick={e => handleMenuOpen('notifications', e)}>
              <Badge badgeContent={data.length} color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <SeparatorVertical />*/}
            <Link className="shopify-status-link" to={`${routes.organization.root.path}#shopify_integration`}>
              <div className="shopify-status">
                <img className="shopify-status-icon" src={shopifyStatusIcon} alt="Shopify status" />
                <div className="shopify-status-text">
                  <p className="shopify-status-label">Shopify</p>
                  <p className={`shopify-status-value ${shopifyStatusClassName}`}>{shopifyStatusLabel}</p>
                </div>
              </div>
            </Link>
            <SeparatorVertical />
            {!isEmptyValue(available_cents) && (
              <>
                <div className="credits">
                  <p className="credits-label">Available credits</p>
                  <p className="credits-value">{localeFormatCurrency({ value: available_cents / 100, minDigits: 0 })}</p>
                </div>
                <SeparatorVertical />
              </>
            )}
            <div className="user" onClick={e => handleMenuOpen('account', e)}>
              <Image className="avatar" image_url={avatar_url} alt="avatar" />
              <p className="user-name">{first_name}</p>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      {renderAccountBadge()}
      {renderNotificationsBadge()}
    </div>
  );
};

export default Navbar;